import { useQuery } from '@tanstack/react-query'
import cx from 'classnames'
import useBackendClient from '~/api/BackendClient/useBackendClient'
import type { CustomCultureStatusIcon } from '~/api/backend/customCultureStatusAPI'
import { QUERY_KEYS } from '~/api/query-client-keys'
import { snakeCaseToTitleCase } from '~/utils/string'
import cs from './culture_status_text.scss'

const iconColorClassMap: Record<CustomCultureStatusIcon, string> = {
  ACTIVE: cs.active,
  READY: cs.ready,
  QUESTION: cs.question,
  ALERT: cs.alert,
  PASSAGED: cs.passaged,
  TERMINATED: cs.terminated,
}

export function CultureStatusText({ status }: { status: string }) {
  const client = useBackendClient()
  const { data: cultureStatuses } = useQuery({
    queryKey: [QUERY_KEYS.CUSTOM_CULTURE_STATUS_LIST],
    queryFn: () => client.customCultureStatuses.getAll(),
  })

  // Find the culture status and get its icon
  const cultureStatus = cultureStatuses?.find(s => s.name === status)
  const iconColorClass = cultureStatus
    ? iconColorClassMap[cultureStatus.icon]
    : cs.cultureStatus

  return (
    <div className={cx(cs.cultureStatus, iconColorClass)}>
      {snakeCaseToTitleCase(status)}
    </div>
  )
}
